import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import { Info } from "../../../../assets/icons";
import { useEffect, useState } from "react";
import { RootState } from "../../../../store/ConfigureStore";
import { HarmonicFilterInstallationType } from "../../../../store/model/calculations/calculation";
import { useSurfaceEquipmentFacade } from "../../../../facade/calculation/calculation-output/surfaceEquipment.facade";
import Error from "../../../../assets/icons/Error";
import TextShortInput from "../../../common/TextShortInput";
import useCalculationFacade from "../../../../facade/calculation/calculation.facade";
import Select from "../../../common/select";

const HarmonicFilter = () => {
  const { harmonicFilterCollapse } = useAppSelector((state) => state?.collapse);
  const selectedTransformer = useAppSelector((state: RootState) => state.surfaceEquipment?.SelectedTransformer);
  const harmonicFilter = useAppSelector((state: RootState) => state.surfaceEquipment?.HarmonicFilter);
  const HarmonicFilterList = useAppSelector((state: RootState) => state.surfaceEquipment?.HarmonicFilterList);
  const driveAmps = useAppSelector((state: RootState) => state.surfaceEquipment?.driveAmps);
  const selectedVSD = useAppSelector((state) => state?.surfaceEquipment?.SelectedVSD);
  const { customerEnabled, customerCreated } = useAppSelector((state) => state?.auth);
  const { projectReadOnly } = useAppSelector((state) => state.projectHeader);
  const { updateHarmonicFilterCollapse } = useCollapseFacade();
  const { updateHfInstallationType, updateHfEstimatedCurrentAmps, updateHfFilterSelection } = useSurfaceEquipmentFacade();
  const { updateSchematicEquipmentData } = useCalculationFacade();
  const handleCollapseChange = (key: boolean) => {
    updateHarmonicFilterCollapse(key);
  };

  const [unit, setUnit] = useState(harmonicFilter?.InstallationType);
  const [AvgCurrentTrend, setAvgCurrentTrend] = useState(driveAmps || 0);
  const [EstimatedCurrentAmps, setEstimatedCurrentAmps] = useState<string | number>("");
  const [partnumner, setPartnumber] = useState(harmonicFilter?.FilterSelection?.harmPN || "");

  const selectedFilterpercent = HarmonicFilterList.find((f) => f.id === harmonicFilter?.FilterSelection?.id);
  const [filterloading, setFilterLoaindg] = useState(selectedFilterpercent?.loadPercentage || "");

  useEffect(() => {
    const installationType = unit;
    let currentTrend = null;
    if (harmonicFilter?.EstimatedCurrentAmps! > 0) {
      const divider = installationType === HarmonicFilterInstallationType.ReRun ? 1.4 : 1.1;
      currentTrend = +((harmonicFilter?.EstimatedCurrentAmps ?? 0) / divider)?.toFixed(2);
    };
    setAvgCurrentTrend(unit === "NWT" ? (driveAmps || currentTrend || 0) : currentTrend || 0);
    setEstimatedCurrentAmps((unit === "NWT" ? ((driveAmps || currentTrend || 0) * 1.1)?.toFixed(2) : currentTrend ? ((currentTrend) * 1.4)?.toFixed(2) : "") ?? harmonicFilter?.EstimatedCurrentAmps?.toString());
  }, [unit, driveAmps]);

  const [selectedFilterId, setSelectedFilterId] = useState(harmonicFilter?.FilterSelection?.id || "");
  const [selectedFilterIds, setSelectedFilterIds] = useState<any[]>([harmonicFilter?.RecommendedFilters?.SingleStage?.id, harmonicFilter?.RecommendedFilters?.DualStage?.id]);

  useEffect(() => {
    setUnit(harmonicFilter?.InstallationType);
    setSelectedFilterId(harmonicFilter?.FilterSelection?.id || "");
    setPartnumber(harmonicFilter?.FilterSelection?.harmPN || "");
    setFilterLoaindg(selectedFilterpercent?.loadPercentage || "");
  }, [harmonicFilter]);

  const handleSelectFilter = (option: any) => {
    if (option?.name === "Select") {
      setSelectedFilterId("");
      setPartnumber("");
      setFilterLoaindg("0");
      updateHfFilterSelection({});
    } else {
      setSelectedFilterId(option?.id);
      setPartnumber(option?.harmPN ? String(option.harmPN) : "");
      setFilterLoaindg(option?.loadPercentage ? String(option?.loadPercentage) : "");
      updateHfFilterSelection(option);
    };
    updateSchematicEquipmentData();
  };

  const handleSelectInstallationType = (value: string) => {
    setUnit(value as HarmonicFilterInstallationType);
    updateHfInstallationType(value as HarmonicFilterInstallationType);
    const type = value as HarmonicFilterInstallationType;
    const Current = type === HarmonicFilterInstallationType.NWT ? +(((driveAmps ?? 0) * 1.1).toFixed(2)) : null
    updateHfInstallationType({
      estimatedCurrentAmps: Current,
      installationType: type
    });
    setSelectedFilterId("");
    setPartnumber("");
    setFilterLoaindg("");
    updateHfFilterSelection({});
    updateSchematicEquipmentData();
  };

  const handleAvergaeCurrentTrendChange = (value: string) => {
    if (value === "") {
      setAvgCurrentTrend(0);
    } else {
      const parsed = parseFloat(value);
      if (!isNaN(parsed)) {
        setAvgCurrentTrend(parsed);
      }
    }
  };


  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e?.target;
    if (name === "AvgCurrent" && unit === "ReRun") {
      const installationType = unit;
      const current = AvgCurrentTrend !== null ? installationType === HarmonicFilterInstallationType.ReRun ? +((AvgCurrentTrend * 1.4).toFixed(2)) : +((AvgCurrentTrend * 1.1).toFixed(2)) : AvgCurrentTrend;
      setEstimatedCurrentAmps(current?.toString() ?? "");
      updateHfEstimatedCurrentAmps(current);
    }
  };

  const showError = selectedVSD && harmonicFilter && harmonicFilter?.FilterSelection?.ampsFilter && selectedVSD?.current_OutField > ((harmonicFilter?.FilterSelection?.ampsFilter || 0) * 1.1);

  const [VSDWorkingAmps, setVSDWorkingAmps] = useState("");
  return (
    <Accordion
      tooltipText="Formulas"
      title="Harmonic filter"
      link={'/help?tab=Surface-Equipment#wapperHarmonicFilter'}
      isOpen={harmonicFilterCollapse}
      onToggle={() => handleCollapseChange(!harmonicFilterCollapse)}
      content={
        <>
          {harmonicFilter && harmonicFilter?.FilterSelection && showError && (<div className="flex flex-col justify-center items-center py-[16px]">
            <div className='flex items-center p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-error-500 border-darkcolor-400'>
              <Error />
              <p className="text-[14px] font-bold leading-[20px] text-neutral-25">
                Filter size is less than VSD rated output amps, recommended to set the VSD limit approx. 10% higher the filter rating of: {harmonicFilter?.FilterSelection?.ampsFilter} x 1.1 = {((harmonicFilter?.FilterSelection?.ampsFilter || 0) * 1.1).toFixed(2)} amps
              </p>
            </div>
          </div>)}
          <div className="grid grid-cols-2 p-4 gap-4">
            <div>
              <div className="flex items-center space-x-4 mb-4">
                <label
                  className="text-[16px] text-neutral-25"
                  style={{ color: "#F7F9F9" }}
                >
                  Install type
                </label>
                <div className="flex space-x-2 border border-[#4A5463] rounded-lg">
                  <button
                    onClick={() => {
                      if (unit !== "NWT") {
                        ((!customerEnabled && !projectReadOnly) || (customerEnabled && customerCreated)) && handleSelectInstallationType(HarmonicFilterInstallationType.NWT);
                      }
                    }}
                    className={`px-4 py-2 rounded-l-lg button-border ${unit === "NWT"
                      ? "bg-gray-100 text-[#60BFDA]"
                      : "bg-gray-100 hover:bg-gray-200 text-white"
                      } transition-colors duration-200`}
                  >
                    NWT
                  </button>
                  <button
                    onClick={() => {
                      if (unit !== "ReRun") {
                        ((!customerEnabled && !projectReadOnly) || (customerEnabled && customerCreated)) && handleSelectInstallationType(HarmonicFilterInstallationType.ReRun);
                      }
                    }}
                    className={`px-4 py-2 rounded-r-lg button-border ${unit === "ReRun"
                      ? "bg-gray-100 text-[#60BFDA]"
                      : "bg-gray-100 hover:bg-gray-200 text-white"
                      } transition-colors duration-200`}
                  >
                    ReRun
                  </button>
                </div>
              </div>

              {unit === "NWT" ? (
                <div className="text-white mb-4">
                  {" "}
                  <h3 className="mb-4">Working current estimation (amps)</h3>
                  {unit === "NWT" && (
                    <div className="flex items-center">
                      <label className="mr-2">VSD working Amps</label>
                      <TextShortInput
                        disabled
                        type="text"
                        value={AvgCurrentTrend}
                        onChange={(e) => handleAvergaeCurrentTrendChange(e.target.value)}
                        readOnly
                        className="w-[80px] px-[8px] py-[4px] border-[1px] rounded-[8px] border-darkcolor-400 bg-transparent focus:outline-none text-neutral-25 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
                      />
                      <span className="mx-2">x 1.1 =</span>
                      {/* <strong>1188.36</strong> */}
                      <strong>{EstimatedCurrentAmps}</strong>
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-white mt-4">
                  <h3 className="mb-2">Working current estimation (amps)</h3>
                  {unit === "ReRun" && (
                    <div className="flex items-center mt-4 mb-4">
                      <label className="mr-2">Avg current trend</label>
                      <TextShortInput
                        type="text"
                        placeholder="Enter value"
                        name="AvgCurrent"
                        value={AvgCurrentTrend}
                        onChange={(e) => handleAvergaeCurrentTrendChange(e.target.value)}
                        onBlur={(e) => handleBlur(e)}
                        className="w-[100px] px-[8px] py-[4px] border-[1px] rounded-[8px] border-darkcolor-400 bg-transparent focus:outline-none text-neutral-25 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500"
                      />
                      <span className="mx-2">x 1.4 =</span>
                      <strong>{EstimatedCurrentAmps}</strong>
                    </div>
                  )}
                </div>
              )}

              <div className="rounded-lg">
                <h3 className="text-[16px] text-white mb-4">
                  Optimum recommended filters
                </h3>
                <div className="flex justify-between items-center bg-[#1E293B] p-2 rounded mb-2">
                  <span className="text-white">Single stage</span>
                  <span className="text-white">{unit === "ReRun" && AvgCurrentTrend === 0 ? "" : `${harmonicFilter?.RecommendedFilters?.SingleStage?.name ?? ""} Loading % ${harmonicFilter?.RecommendedFilters?.SingleStage?.loadPercentage ?? ""}`}</span>
                </div>
                <div className="flex justify-between items-center bg-[#1E293B] p-2 rounded mb-2">
                  <span className="text-white">Dual stage</span>
                  <span className="text-white">{unit === "ReRun" && AvgCurrentTrend === 0 ? "" : `${harmonicFilter?.RecommendedFilters?.DualStage?.name ?? ""} Loading % ${harmonicFilter?.RecommendedFilters?.DualStage?.loadPercentage ?? ""}`}</span>
                </div>
                <div className="flex flex-col bg-[#1E293B] rounded">
                  <div className="flex justify-between items-center p-2">
                    <span className="text-white">Filter</span>
                    <Select
                      label=""
                      options={HarmonicFilterList || []}
                      onChange={handleSelectFilter}
                      selectedValue={selectedFilterId ?? ""}
                      dropdownDirection="up"
                      showCloseIcon={true}
                      onClear={() => handleSelectFilter({ id: "", name: "Select" })}
                      width="300px"
                      padding="px-[14px] py-[5px]"
                      fontSize="16px"
                      className="sm:px-0 px-[10px] w-[224px]"
                      name="hfilter"
                      isWrap={true}
                    />
                    <span className="text-white">Loading % {filterloading}</span>
                  </div>
                  <div className="border-t-[1px] border-darkcolor-400 p-2 text-white">PN:<span className="text-white pl-6">{partnumner}</span></div>
                </div>
              </div>
            </div>
            <div className="space-x-4">
              <div className="p-[12px] gap-[12px] rounded-[8px] border-[1px] bg-primary-600 border-darkcolor-400 flex items-start">
                <Info className="text-[#F4FBFC] text-[32px]" />
                <div>
                  <h3 className="text-[16px] mb-2 text-[#F4FBFC]">Note:</h3>
                  <ul className="list-disc ml-6 text-sm text-[#F4FBFC]">
                    <li>
                      For optimal performance, the VSD should be operating at
                      greater than 50% of rated output amps.
                    </li>
                    <li>
                      Exception: A 500kVA smarton VSD operating at greater than
                      90% rated output amps continuously (with no plans for
                      reduction in load and with greater than 5% background
                      (THD)). In this case, a single stage 636A filter (or Dual
                      stage 640A) would be a better choice.
                    </li>
                    <li>
                      If a 200A VSD is being utilized and will be loaded at less
                      than 50% rated output amps, then an appropriately sized
                      single stage filter is recommended.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    />
  );
};

export default HarmonicFilter;
